import React, { useEffect, useState, memo } from 'react';
import '../../../assets/sass/uiV3/component/_myActivity.scss';
import ProgressBar from './ProgressBar';
// import ProgressBar from 'react-bootstrap/ProgressBar';

import { Accordion, ProgressBar as BootstrapProgressBar } from 'react-bootstrap';
import {
  useGetUserCmePointsAchived,
  useGetUserGoal,
  useGetUserGoalAchived
} from '../../../Queries/QueryHooks/user.hook';
import { getSessionStorage, log, setSessionStorage } from '../../../common/common';
import { useDispatch } from 'react-redux';
import { getUserPoints } from '../../../Store/actions/spq.action';
import { MyActivitySkeleton } from '../../../skeleton/uiv3/MyActivitySkeleton';
const MyActivity = () => {
  const dispatch = useDispatch();
  const [points, setPoints] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [achivedUserGoal, setAchivedUserGoal] = useState({
    article_read: {
      total_goal: 0,
      content_type: 'medwiki'
    },
    video_watched: {
      total_goal: 0,
      content_type: 'archived_video'
    },
    attended_cme: {
      total_goal: 0,
      content_type: 'session'
    }
  });
  const [userGoal, setuserGoal] = useState({
    read: 0,
    watch: 0,
    discuss: 0,
    cme_point: 0
  });
  const { data: goalData, isLoading: goalLoader } = useGetUserGoal();
  const { data: achivedGoalData, isLoading: achivedGoalLoader } = useGetUserGoalAchived();
  const { data: cmePoints, isLoading: cmePointsLoader } = useGetUserCmePointsAchived();

  function nextMultipleOfTen(num) {
    return Math.ceil(num / 10) * 10;
  }

  useEffect(() => {
    console.log('temptest -1', achivedGoalData);
    if (goalData || achivedGoalData) {
      console.group('goalData');
      const { user_goal = '' } = goalData ?? {};
      console.log('goal_on', user_goal);
      let temp_obj = user_goal ? JSON.parse(user_goal) : {};
      if (getSessionStorage('user_goal', false) || getSessionStorage('goal_achieved', false)) {
        let obj_from_storage = JSON.parse(getSessionStorage('user_goal', '{}'));
        let achived_from_storage = JSON.parse(getSessionStorage('goal_achieved', '{}'));
        console.log('achived_from_storage', achived_from_storage, achivedGoalData);
        const {
          article_read = 0,
          attended_cme = 0,
          video_watched = 0
        } = achived_from_storage || {};
        console.log(
          'obj_from_storage',
          obj_from_storage,
          article_read,
          attended_cme,
          video_watched
        );
        console.groupEnd('goalData');
        setuserGoal((prev) => {
          let temp = { ...prev };
          temp.read = Math.max(
            temp_obj?.read,
            nextMultipleOfTen(parseInt(article_read?.total_goal ?? 0)),
            nextMultipleOfTen(parseInt(achivedGoalData?.goal_achieved?.article_read?.total_goal))
          );
          temp.watch = Math.max(
            temp_obj?.watch,
            nextMultipleOfTen(parseInt(video_watched?.total_goal ?? 0)),
            nextMultipleOfTen(parseInt(achivedGoalData?.goal_achieved?.video_watched?.total_goal))
          );
          temp.discuss = Math.max(
            temp_obj?.discuss,
            nextMultipleOfTen(parseInt(attended_cme?.total_goal ?? 0)),
            nextMultipleOfTen(parseInt(achivedGoalData?.goal_achieved?.attended_cme?.total_goal))
          );
          temp.cme_point =
            cmePoints > temp_obj?.cme_point
              ? nextMultipleOfTen(parseInt(cmePoints))
              : nextMultipleOfTen(parseInt(temp_obj?.cme_point));

          console.log('temptest', temp_obj, achived_from_storage, temp, achivedUserGoal);
          return temp;
        });
      } else if (user_goal) {
        console.log('user_goal', user_goal, achivedGoalData);
        setuserGoal(JSON.parse(user_goal));
        setSessionStorage('user_goal', user_goal);
      } else {
        setuserGoal({
          read: 0,
          watch: 0,
          discuss: 0,
          cme_point: 0
        });
      }
    }
    getTotalPercentage();
    return () => {};
  }, [goalData, cmePoints, achivedGoalData]);

  useEffect(() => {
    console.group('achivedGoalData');
    if (achivedGoalData) {
      const { goal_achieved } = achivedGoalData;
      console.log('goal on 2', goal_achieved);
      if (getSessionStorage('goal_achieved', false)) {
        let object_from_storage = JSON.parse(getSessionStorage('goal_achieved', '{}'));
        console.log('object_from_storage', object_from_storage);
        if (
          object_from_storage &&
          typeof object_from_storage == 'object' &&
          Object.keys(object_from_storage).length > 0
        ) {
          console.log('goal_achieved 1', object_from_storage);

          setAchivedUserGoal((prev) => {
            console.log('prev', prev);
            // return { ...prev };
            let temp = { ...prev };
            temp.article_read.total_goal = Math.max(
              parseInt(temp.article_read?.total_goal ?? 0),
              parseInt(object_from_storage?.article_read?.total_goal ?? 0)
            );
            temp.video_watched.total_goal = Math.max(
              parseInt(temp.video_watched?.total_goal ?? 0),
              parseInt(object_from_storage?.video_watched?.total_goal ?? 0)
            );
            temp.attended_cme.total_goal = Math.max(
              parseInt(temp.attended_cme?.total_goal ?? 0),
              parseInt(object_from_storage?.attended_cme?.total_goal ?? 0)
            );
            console.log('temp', temp, object_from_storage);
            return temp;
          });
        } else {
          console.log('goal_achieved 2', goal_achieved);
        }
      } else {
        console.log('goal_achieved 3', goal_achieved);
        setAchivedUserGoal(goal_achieved);
        setSessionStorage('goal_achieved', JSON.stringify(goal_achieved));
      }
    }
    console.groupEnd('achivedGoalData');
    return () => {};
  }, [achivedGoalData]);

  useEffect(() => {
    dispatch(
      getUserPoints((res) => {
        setPoints(res?.data);
      })
    );
  }, []);

  function getTotalPercentage() {
    const denominator =
      parseInt(userGoal?.read && !isNaN(userGoal?.read) ? userGoal?.read : 10) +
      parseInt(userGoal?.watch && !isNaN(userGoal?.watch) ? userGoal?.watch : 10) +
      parseInt(userGoal?.discuss ? userGoal?.discuss : 10) +
      parseInt(userGoal?.cme_point && !isNaN(userGoal?.cme_point) ? userGoal?.cme_point : 10);

    const numerator =
      parseInt(achivedUserGoal?.article_read?.total_goal ?? 0) +
      parseInt(achivedUserGoal?.video_watched?.total_goal ?? 0) +
      parseInt(achivedUserGoal?.attended_cme?.total_goal ?? 0) +
      parseInt(cmePoints ?? 0);

    const percentage = (numerator / denominator) * 100;
    setPercentage(Math.round(percentage));
  }

  useEffect(() => {
    getTotalPercentage();
  }, [userGoal, achivedUserGoal, cmePoints]);

  return (
    <Accordion defaultActiveKey="1">
      <Accordion.Item
        eventKey="1"
        className="w-100 d-flex flex-column gap-3 bg-extra-light rounded-3 text-center p-3 p-sm-4 clr_v3_myActivity"
      >
        <Accordion.Header>
          <h2 className="fs-3 fw-semibold text-black">My Activity</h2>
          <div className="d-flex gap-3 align-items-center">
            <BootstrapProgressBar
              variant="primary"
              now={percentage}
              className="clr_v3_myActivity__ttlProgress"
            />
            {/* <ProgressBar now={30} /> */}
            <span className="text-primary">{percentage} %</span>
          </div>
        </Accordion.Header>
        <Accordion.Body className="d-flex flex-column">
          {goalLoader || achivedGoalLoader ? (
            <MyActivitySkeleton />
          ) : (
            <div className="clr_v3_myActivity__container d-flex flex-wrap mt-3 mt-sm-4">
              <div className="col-6 flex-grow-1 p-sm-4 p-3 text-start border-start border-top clr_v3_myActivity__box">
                <ProgressBar
                  title="Read"
                  rating={`${achivedUserGoal?.article_read?.total_goal ?? 0}/${
                    userGoal?.read && !isNaN(userGoal?.read) ? userGoal?.read : 10
                  }`}
                />
              </div>
              <div className="col-6 flex-grow-1 p-sm-4 p-3 text-start border-start border-top clr_v3_myActivity__box">
                <ProgressBar
                  title="Watched"
                  rating={`${achivedUserGoal?.video_watched?.total_goal ?? 0}/${
                    userGoal?.watch && !isNaN(userGoal?.watch) ? userGoal?.watch : 10
                  }`}
                />
              </div>
              <div className="col-6 flex-grow-1 p-sm-4 p-3 text-start border-start border-top clr_v3_myActivity__box">
                <ProgressBar
                  title="CME"
                  rating={`${achivedUserGoal?.attended_cme?.total_goal ?? 0}/${
                    userGoal?.discuss ? userGoal?.discuss : 10
                  }`}
                />
              </div>
              <div className="col-6 flex-grow-1 p-sm-4 p-3 text-start border-start border-top clr_v3_myActivity__box">
                <ProgressBar
                  title="CME Points"
                  rating={`${cmePoints ?? 0}/${
                    userGoal?.cme_point && !isNaN(userGoal?.cme_point) ? userGoal?.cme_point : 10
                  }`}
                />
              </div>
            </div>
          )}

          <div className="bg-body p-3 rounded-3 d-flex justify-content-between align-items-center mt-20">
            <h4 className="fs-16 text-dark fw-medium">Points Earned</h4>
            <h2 className="fs-2 text-black fw-semibold">{points}</h2>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
export default memo(MyActivity);
